<header class="navbar sticky-top bg-primary navbar-expand-lg flex-md-nowrap p-0 shadow">
  <div class="d-flex align-items-center d-md-none">
    <button
      class="nav-link px-3 text-white border-0 bg-transparent mobile-menu-btn"
      type="button"
      data-bs-toggle="offcanvas"
      data-bs-target="#sidebarMenu"
      aria-controls="sidebarMenu"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <i class="bi bi-list"></i>
    </button>
  </div>
  <a class="navbar-brand col-md-3 col-lg-2 me-0 px-3 fs-6" href="#">
    <img src="assets/logo/truckit.svg" alt="image" />
  </a>
  <ul class="navbar-nav d-flex flex-row d-md-none align-items-center gap-3">
    <li class="nav-item text-nowrap">
      <div ngbDropdown class="d-inline-block" display="dynamic" placement="bottom-end">
        <div role="button" id="notificationDropDownMobileView" ngbDropdownToggle class="d-flex align-content-center notification-toggle text-white">
          <i class="bi bi-bell text-center"></i>
        </div>
        <div ngbDropdownMenu aria-labelledby="notificationDropDownMobileView">
          <div class="d-flex flex-column align-items-start overflow-y-scroll" style="min-width: 280px; max-width: calc(100vw - 2rem); max-height: 450px">
            <div *ngFor="let n of notificationList" class="d-flex flex-column border-bottom p-3 gap-2" ngbDropdownItem>
              <div class="d-flex flex-row gap-3 align-items-start">
                <div id="notificationIcon" class="d-flex rounded-circle">
                  <i class="text-center bi bi-info-circle-fill fs-3" style="width: 2rem !important; height: 2rem !important"></i>
                </div>
                <div class="d-flex flex-column gap-2">
                  <div class="text-wrap" [innerHTML]="n.message"></div>
                  <div class="text-muted">{{ getTimeAgo(n.created_at) }}</div>
                  <div class="d-flex flex-row gap-2">
                    <a href="{{ n.target_url }}" class="btn btn-sm" target="_blank">View</a>
                    <button class="btn btn-sm" style="color: #f05a29">Dismiss</button>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="notificationList.length > 0" class="w-100">
              <div class="d-grid gap-2">
                <button class="btn btn-sm btn-block" [disabled]="notificationsLoading" (click)="fetchNotifications()">
                  <span *ngIf="!notificationsLoading">Load More</span>
                  <span *ngIf="notificationsLoading">
                    <i class="bi bi-arrow-repeat spin"></i>
                    Loading...
                  </span>
                </button>
              </div>
            </div>
            <div *ngIf="notificationError" class="w-100 px-3 py-2 text-center">
              <div class="small text-danger">{{ notificationError }}</div>
            </div>
            <div *ngIf="notificationList.length === 0 && !notificationsLoading" class="d-flex justify-content-center align-items-center text-center my-3" style="height: 100px">
              No notifications available
            </div>
          </div>
        </div>
      </div>
    </li>
  </ul>
  <div class="collapse navbar-collapse p-4" id="navbarText">
    <ul class="navbar-nav gap-5 me-auto mb-2 mb-lg-0">
      <ng-container *ngFor="let navItem of topLevelMenuItems">
        <!-- For items without children -->
        <li *ngIf="!navItem.childrenColumnOne.length && !navItem.childrenColumnTwo.length" class="nav-item">
          <a class="nav-link text-white lh-base" href="{{ navItem.item.route }}" (click)="onMenuItemClick(navItem.item, $event)" target="_blank">{{ navItem.item.name }}</a>
        </li>

        <!-- For the dropdown menu (Create a shipment) -->
        <li
          *ngIf="navItem.childrenColumnOne && navItem.childrenColumnOne.length > 0"
          class="nav-item"
          ngbDropdown
          #csDropdown="ngbDropdown"
          display="dynamic"
          (mouseenter)="$event.stopPropagation(); csDropdown.open()"
          (mouseleave)="$event.stopPropagation(); csDropdown.close()"
        >
          <button type="button" class="btn btn-outline-light" ngbDropdownToggle>{{ navItem.item.name }}</button>
          <div ngbDropdownMenu aria-labelledby="createShipmentDropDown">
            <div class="d-flex flex-row align-items-center">
              <div class="d-flex flex-column align-items-start p-1 gap-2" style="min-width: 310px">
                <a [href]="cs.route" target="_blank" *ngFor="let cs of navItem.childrenColumnOne" class="px-1 csDropDowmItem" role="button" ngbDropdownItem>
                  <div class="d-flex flex-row align-items-center justify-content-between p-2" *ngIf="cs.index_column == 1">
                    <div class="d-flex flex-row align-items-center gap-2">
                      <span class=""><img [src]="cs.icon" alt="" /></span>
                      <span class="fst-normal fs-6 lh-base">{{ cs.name }}</span>
                    </div>

                    <span class=""><img src="assets/icons/fi_arrow-right.svg" class="csDropDowmItemEndIcon d-none" alt="" /></span>
                  </div>
                </a>
              </div>
              <div class="d-flex flex-column align-items-start p-1 gap-2" style="min-width: 310px">
                <a [href]="cs.route" target="_blank" *ngFor="let cs of navItem.childrenColumnTwo" class="px-1 csDropDowmItem" role="button" ngbDropdownItem>
                  <div class="d-flex flex-row align-items-center justify-content-between p-2" *ngIf="cs.index_column == 2">
                    <div class="d-flex flex-row align-items-center gap-2">
                      <span class=""><img [src]="cs.icon" alt="" /></span>
                      <span class="fst-normal fs-6 lh-base">{{ cs.name }}</span>
                    </div>

                    <span class=""><img src="assets/icons/fi_arrow-right.svg" class="csDropDowmItemEndIcon d-none" alt="" /></span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </li>
      </ng-container>
    </ul>

    <div class="nav-right d-flex flex-row align-items-center gap-3">
      <!-- Job Status Icon -->
      <app-job-status-bar *ngIf="(userModeService.mode$ | async) === 'provider'"></app-job-status-bar>

      <!-- Notification Bell -->
      <div ngbDropdown display="dynamic" placement="bottom-end">
        <div role="button" id="notificationBell" class="header-icon-btn position-relative" ngbDropdownToggle aria-label="Notifications">
          <i class="bi bi-bell"></i>
          <span *ngIf="notificationList.length > 0" class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style="font-size: 0.55rem; padding: 0.15rem 0.35rem">
            {{ notificationList.length > 99 ? '99+' : notificationList.length }}
          </span>
        </div>
        <div ngbDropdownMenu aria-labelledby="notificationBell" class="dropdown-menu-end notification-dropdown p-0">
          <div class="notification-panel">
            <div class="d-flex align-items-center justify-content-between px-3 py-2 border-bottom bg-light">
              <span class="fw-bold small text-dark">Notifications</span>
            </div>
            <div class="overflow-y-auto" style="max-height: 380px">
              <div *ngFor="let n of notificationList" class="d-flex gap-3 px-3 py-3 border-bottom notification-item" ngbDropdownItem>
                <div class="notification-icon-circle flex-shrink-0">
                  <i class="bi bi-info-circle-fill"></i>
                </div>
                <div class="flex-grow-1 min-w-0">
                  <div class="text-wrap small" [innerHTML]="n.message"></div>
                  <div class="text-muted mt-1" style="font-size: 0.7rem">{{ getTimeAgo(n.created_at) }}</div>
                  <div class="d-flex gap-2 mt-2">
                    <a href="{{ n.target_url }}" class="btn btn-sm btn-outline-secondary py-0 px-2" style="font-size: 0.7rem" target="_blank">View</a>
                    <button class="btn btn-sm btn-link text-danger p-0" style="font-size: 0.7rem">Dismiss</button>
                  </div>
                </div>
              </div>
              <div *ngIf="notificationList.length > 0" class="p-2 text-center border-top">
                <button class="btn btn-sm btn-link text-decoration-none" [disabled]="notificationsLoading" (click)="fetchNotifications()">
                  <span *ngIf="!notificationsLoading">Load More</span>
                  <span *ngIf="notificationsLoading">
                    <i class="bi bi-arrow-repeat spin"></i>
                    Loading...
                  </span>
                </button>
              </div>
              <div *ngIf="notificationError" class="p-2 text-center border-top">
                <div class="small text-danger">{{ notificationError }}</div>
              </div>
              <div *ngIf="notificationList.length === 0 && !notificationsLoading" class="d-flex flex-column align-items-center justify-content-center py-4 text-muted">
                <i class="bi bi-bell-slash fs-3 mb-2 opacity-50"></i>
                <div class="small">No notifications</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Profile Dropdown -->
      <div ngbDropdown display="dynamic" placement="bottom-end">
        <div role="button" id="accountDropdown" class="header-profile-btn d-flex align-items-center gap-2" ngbDropdownToggle>
          <!-- Avatar (always rendered, with placeholder) -->
          <div class="profile-avatar">
            <img *ngIf="profilePic" class="rounded-circle" [src]="profilePic" alt="Profile" />
            <span *ngIf="!profilePic" class="avatar-placeholder">
              {{ (customerDetails?.firstname || '?')[0] | uppercase }}
            </span>
          </div>
          <!-- Name (skeleton while loading) -->
          <div class="d-none d-lg-flex flex-column align-items-start">
            <div *ngIf="customerDetails; else nameSkeleton" class="text-white fw-semibold text-truncate lh-sm" style="max-width: 120px; font-size: 0.8rem">
              {{ customerDetails.firstname }}
            </div>
            <ng-template #nameSkeleton>
              <div class="skeleton-text" style="width: 80px; height: 10px"></div>
            </ng-template>
            <div *ngIf="customerDetails" class="text-white-50 text-truncate" style="max-width: 120px; font-size: 0.65rem">
              {{ customerDetails.business_name }}
            </div>
          </div>
          <i class="bi bi-chevron-down text-white-50 d-none d-lg-inline" style="font-size: 0.65rem"></i>
        </div>

        <div ngbDropdownMenu aria-labelledby="accountDropdown" class="dropdown-menu-end">
          <div class="d-flex flex-column gap-1 py-1">
            <a [href]="logoutUrl" class="d-flex align-items-center gap-2 px-3 py-2" ngbDropdownItem>
              <i class="bi bi-box-arrow-right"></i>
              <span>Log Out</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</header>
